module.exports = __webpack_public_path__ + "assets/img/step-4.f5aac80d.png";